import axios from 'axios';
import { AnalyticsUserInfo } from './service';

const { NEXT_FRESHPAINT_ID } = process.env;

export const sendServerEvent = async (
  eventName: string,
  user: AnalyticsUserInfo,
  properties?: Object
): Promise<void> => {
  try {
    await axios.post('https://api.perfalytics.com/track', {
      event: eventName,
      properties: {
        distinct_id: user.id,
        userIdType: user.idType,
        token: NEXT_FRESHPAINT_ID,
        time: Date.now() / 1000,
        ...properties,
      },
    });
  } catch (error) {
    console.error(error.message);
  }
};
